import { getTransferRequests } from 'client/stock-transfers/stock-transfers.client'

export const shipmentLoader = async () => {
  return await getTransferRequests(['inLoading', 'partiallyShipped'])
}
